import React from "react";
import RegisterInstallerForm from "../../forms/auth/RegisterInstallerForm";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(10),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
  },
}));

const RegisterInstallerView = ({ onSubmit = () => {}, initialValues }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <RegisterInstallerForm
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
    </Box>
  );
};

export default RegisterInstallerView;
